export { default } from '../order-summary';
